import axios from "axios";
// export const rootUrl = process.env.VUE_APP_API_URL;
export const rootUrl = process.env.VUE_APP_API_URL;

export const host = `${rootUrl}`;
export const base = `${rootUrl}`;

export const http = axios.create({ 
  timeout: 1000000
});
















































